import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import 'react-phone-number-input/style.css';
import API from '../../utils/API';
import * as modalUtils from '../../utils/modalUtils';
import useModalInitialization from '../../hooks/useModalInitialization';
import constants from '../../utils/constants'

const modalId = 'usersAssignSiteModal';

function UsersAssignSiteModal(props) {
  const { selectedUserIds, setSuccess, setError, dataMap, loadTable } = props;
  
  // Use the modal initialization hook
  const {
    // State
    cms,
    cmses,
    selectedSiteIds,
    cmsDropdownError,
    siteDropdownError,
    
    // Setters
    setCmsDropdownError,
    
    // Computed values
    selectedSitesCount,
    selectedSitesText,
    
    // Handlers
    handleCmsClick,
    closeModal,
    
    // Helper functions
    generateSiteComponents
  } = useModalInitialization({
    modalId,
    selectedUserIds,
    dataMap,
    siteExtractor: modalUtils.extractStringBasedSiteInfo
  });
  
  // Feature-specific state (not handled by the hook)
  const [features] = useState([{id: constants.featureIds.msgManager/*"f07b57b8-a1a0-470a-8dc8-6811e649eab2"*/, name: 'Message Manager'}, {id: constants.featureIds.signagePlus/*"9aeaf825-0152-49b0-aa38-79ae9998ef6e"*/, name: 'Signage Plus'}]);
  const [selectedFeatureIds, setFeatureIds] = useState({/*"f07b57b8-a1a0-470a-8dc8-6811e649eab2":true*/});
  const [featureDropdownError, setFeatureDropdownError] = useState('');

  // Reset feature error when modal is shown/hidden
  useEffect(() => {
    const modal = document.getElementById(modalId);
    
    if (modal) {
      const handleModalShow = () => {
        setFeatureDropdownError('');
      };
      
      const handleModalHidden = () => {
        setFeatureDropdownError('');
      };
      
      modal.addEventListener('show.bs.modal', handleModalShow);
      modal.addEventListener('hidden.bs.modal', handleModalHidden);
      
      return () => {
        modal.removeEventListener('show.bs.modal', handleModalShow);
        modal.removeEventListener('hidden.bs.modal', handleModalHidden);
      };
    }
  }, []);


  
  // closeModal is now provided by the hook

  // handleCmsClick is now provided by the hook

  // handleSiteClick is now provided by the hook

  // Site components generation is now provided by the hook

  const onSave = async () => {
    if (!cms) {
      setCmsDropdownError(<FormattedMessage id="NO_CMS_SELECTED" />);
    }
    //Bug #19054 Cannot De-assign Roles or Sites from users.
    /*if (selectedSitesCount === 0) {
      setSiteDropdownError(<FormattedMessage id="NO_SITES_SELECTED" />);
    }*/
    if (selectedFeaturesCount === 0) {
      setFeatureDropdownError(<FormattedMessage id="NO_FEATURES_SELECTED" />);
    }
    if (!cms /*|| selectedSitesCount === 0*/ || selectedFeaturesCount === 0) {
      return; // Prevent API call if there's an error
    }

    try {
      console.log('assigning sites for msg manager', selectedSiteIds, selectedUserIds);
      const featureIdsToAssign = Object.keys(selectedFeatureIds).filter((featureId) => selectedFeatureIds[featureId] === true);
      await Promise.all(
        featureIdsToAssign.map((featureId) => {
          switch (featureId) {
            case constants.featureIds.msgManager: // Message Manager
              return API.putAssignSitesForMsgManagerUsr(cms, selectedSiteIds, selectedUserIds);
            case constants.featureIds.signagePlus: // Signage Plus
              return API.putAssignSitesForSignagePlusUsr(cms, selectedSiteIds, selectedUserIds);
            default:
              console.warn(`Unknown feature ID: ${featureId}`);
              return Promise.resolve();
          }
        })
      );

      setSuccess(<FormattedMessage id="ASSIGN_SITE_SUCCESS" />);
      closeModal();
      await loadTable(dataMap, false);
    } catch (e) {
      console.error(e);
      setError(<FormattedMessage id="ASSIGN_SITE_FAIL" />);
    }
  };



  // Get site components from the hook
  const siteComponents = generateSiteComponents();
  const hasSites = siteComponents.length > 0;

  useEffect(() => {
    console.log('selectedSiteIds:', selectedSiteIds);
  }, [selectedSiteIds]);

  function handleFeatureClick(featureId, e) {
    e.stopPropagation();
    let selectedFeaCounts = Object.keys(selectedFeatureIds).length;
    if (selectedFeaCounts > 0 && featureId in selectedFeatureIds) {
      selectedFeatureIds[featureId] = !selectedFeatureIds[featureId];
    } else {
      selectedFeatureIds[featureId] = true;
    }
    const updatedFeatureIds = { ...selectedFeatureIds };
    setFeatureIds(updatedFeatureIds);
  }
  const generateFeatureComponents = (tier = 0) => {
       let featureComponents = Object.keys(features).map((key) => {
        const padding = tier * 8;
        return (
          <li style={{ paddingLeft: padding }} key={features[key].id} value={features[key].id} onClick={(e) => { handleFeatureClick(features[key].id, e) }}>
            <span className='dropdown-item'>
              <input 
                key={`checkbox-${features[key].id}`} 
                type="checkbox" style={{ marginRight: 8 }} 
                /*disabled={false}*/ 
                checked={selectedFeatureIds[features[key].id] === true}
                readOnly
              />
              {/*features[key].name*/}
              <FormattedMessage id={`${features[key].id}-FEATURENAME`} />
            </span>
          </li>
        );
      })
      return featureComponents;
  };
  const featureComponents = generateFeatureComponents();
  useEffect(() => {
    console.log('selectedFeatureIds:', selectedFeatureIds);
  }, [selectedFeatureIds]);

  const selectedFeatureNames =  Object.keys(selectedFeatureIds).filter(id => selectedFeatureIds[id]).map(id => {
    let feature = features.find(f => f.id === id);
    return feature ? feature.name : '';
  }).filter(name => name !== '');

  const selectedFeaturesCount = selectedFeatureNames.length;
  const selectedFeaturesText = selectedFeatureNames.join(', ');

  return (
    <div className="modal fade" id={modalId} tabIndex="-1" aria-labelledby="roleModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content" style={{ overflow: 'visible' }}>
          <div className="modal-header">
            <h5 className="modal-title"><FormattedMessage id="ASSIGN_CMS_SITE" defaultMessage="Assign CMS/Site" /></h5>
            <button type="button" id="closeSitesModal" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={closeModal}></button>
          </div>
          <div className="modal-body" style={{ overflow: 'visible' }}>
          <div style={{ fontWeight: 'bolder' }}><FormattedMessage id="FEATURE" /></div>
            <div className="dropdown">
              <button
                style={{ width: '100%', textAlign: 'left', backgroundColor: 'white', color: 'black', border: '1px solid #ced4da' }}
                className="btn btn-secondary form-select"
                type="button"
                id="featureDropdownMenu"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                disabled={/*true*/false}
              >
                 <span style={{ fontWeight: 'bold' }}>{selectedFeaturesCount} <FormattedMessage id="SELECTED_TEXT" /></span>
                 <span style={{ color: '#6c757d', marginLeft: '10px' }}>{selectedFeaturesText}</span>
              </button>
              <ul
                style={{ textAlign: 'left'}}
                className="dropdown-menu"
                aria-labelledby="featureDropdownMenu"
              >
                {featureComponents}
  
              </ul>
            </div>
            {featureDropdownError && <div className="text-danger" role="alert">{featureDropdownError}</div>}
            <div style={{ fontWeight: 'bolder', marginTop: '10px' }}><FormattedMessage id="CMS" /></div>
            <div className="dropdown">
              <button
                style={{ width: '100%', textAlign: 'left', backgroundColor: 'white', color: 'black', border: '1px solid #ced4da' }}
                className="btn btn-secondary form-select"
                type="button"
                id="cmsDropdownMenu"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {cms ? cmses.find(c => c.id === cms)?.name : <FormattedMessage id="SELECT_CMS" />}
              </button>
              <ul
                style={{ textAlign: 'left'}}
                className="dropdown-menu"
                aria-labelledby="cmsDropdownMenu"
              >
                {cmses.map(cmsObj => (
                  <li id="cmsItem" key={cmsObj.id} onClick={() => handleCmsClick(cmsObj.id)}>
                    <span className="dropdown-item">{cmsObj.name}</span>
                  </li>
                ))}
              </ul>
            </div>
            {cmsDropdownError && <div className="text-danger" role="alert">{cmsDropdownError}</div>}
            <div style={{ fontWeight: 'bolder', marginTop: '10px' }}><FormattedMessage id="SITE" /></div>
            <div className="dropdown">
              <button
                style={{ width: '100%', textAlign: 'left', backgroundColor: 'white', color: 'black', border: '1px solid #ced4da', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                className="btn btn-secondary form-select"
                type="button"
                id="siteDropdownMenu"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                disabled={!hasSites}
                data-bs-display="static"
              >
                <span style={{ fontWeight: 'bold' }}>{selectedSitesCount} <FormattedMessage id="SELECTED_TEXT" /></span>
                <span style={{ color: '#6c757d', marginLeft: '10px' }}>{selectedSitesText}</span>
              </button>
              <ul
                style={{ textAlign: 'left' }}
                className="dropdown-menu dropdown-menu-start"
                aria-labelledby="siteDropdownMenu"
              >
                {siteComponents}
              </ul>
            </div>
            {siteDropdownError && <div className="text-danger" role="alert">{siteDropdownError}</div>}
          </div>
          <div className="modal-footer justify-content-between">
            <button id="assignSiteBackBtn" className="btn back-btn" type="button" data-bs-dismiss="modal"><FormattedMessage id="BACK" /></button>
            <button id="assignSiteSaveBtn" className="btn save-btn ms-2" type="submit" onClick={onSave}><FormattedMessage id="SAVE" /></button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UsersAssignSiteModal;
